import { render } from "./HeroAuthTravelDashboard.vue?vue&type=template&id=748b9bbc&scoped=true"
import script from "./HeroAuthTravelDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthTravelDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthTravelDashboard.vue?vue&type=style&index=0&id=748b9bbc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748b9bbc"]])

export default __exports__